import { useList } from "../data";
import SectionHead from "./SectionHead";

export default function Usage() {
  return (
    <section id="use" className="bg-background-50 py-14 md:py-20">
      <div className="wrap">
        <SectionHead
          no="05"
          title="别人发数字梗，怎么接不冷场"
          desc="「吃瓜91」真正的用法在聊天里。别急着找定义，先接住那个“一起围观”的气氛。下面给你几种接法。"
          tone="accent"
        />

        <div className="mt-10 grid gap-4 md:grid-cols-2">
          {useList.map((u) => (
            <article
              key={u.title}
              className="flex gap-4 rounded-lg border border-background-200 bg-background-100 p-5 transition-colors hover:border-primary-200"
            >
              <span className="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-chat-smile-3-line h-5 w-5 flex items-center justify-center" />
              </span>
              <div>
                <div className="mb-1.5 inline-flex items-center gap-1.5">
                  <span className="rounded-md bg-secondary-100 px-1.5 py-0.5 text-[11px] font-semibold text-secondary-900">
                    {u.k}
                  </span>
                </div>
                <h3 className="eyebrow text-base font-bold text-foreground-950">{u.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{u.summary}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}